export default __webpack_public_path__ + "static/warehouse-74d77a615375d1db4be4ffa2ca353d9c.jpg";